import { FC, useState } from "react";
import styled from "styled-components";
import { ViewType } from "../../../page/enums/ViewType";
import { SortInactiveIcon, SortActiveIcon } from "./rowIcons";
import { TableHeaderColumnItem } from "./TableHeaderColumnItem";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

const TableRow = styled.tr`
    border-bottom: 1px solid #dddddd;
    height: 50px;
    background-color: #f1f1f1;
`
const TableHeaderColumn = styled.td`
    padding: 0 10px 0 10px;
    cursor: pointer;
`
const TableHeaderLastColumn = styled.td.attrs({ colSpan: 5 })`
    padding: 0 10px 0 10px;
`
const TableHeaderColumnButton = styled.button`
    background-color: #f1f1f1;
    border: none;
    font-weight: 700;
    padding: 0;
    cursor: pointer;
`

interface TableHeaderRowProps {
    tableColumns: TableHeaderColumnItem[];
    activateSort?: (newSortParam: string) => void;
    type: ViewType;
    onUpdate: () => void;
}

const TableHeaderRow: FC<TableHeaderRowProps> = (props) => {
    const { t } = useCustomTranslation();
    const [sortedTab, setSortedTab] = useState<string>("");

    function handleClick(tableColumn: TableHeaderColumnItem) {
        setSortedTab(tableColumn.columnName);
        props.activateSort && props.activateSort(tableColumn.sortParam)
    }

    return (
        <TableRow>
            {props.tableColumns.map((tableColumn, index) => (
                <TableHeaderColumn key={index} onClick={() => handleClick(tableColumn)}>
                    {!tableColumn.sortParam ? null
                        : sortedTab === tableColumn.columnName ? <SortActiveIcon /> : <SortInactiveIcon />
                    }
                    {tableColumn.columnName &&
                    <TableHeaderColumnButton aria-labelledby="columnNameButton" id="columnNameButton">
                        {t(tableColumn.columnName)}
                    </TableHeaderColumnButton>}

                </TableHeaderColumn>
            ))}

            {/*Extra column for decline/accept buttons*/}
            {props.type === ViewType.RECEIVED_APPLICATIONS &&
                <TableHeaderLastColumn />}

            {props.type === ViewType.SENT_APPLICATIONS &&
                <TableHeaderLastColumn />
            }
        </TableRow>
    )
}

export default TableHeaderRow;